import CalendarWithArrowLeftIcon from "@/components/icons/CalendarWithArrowLeftIcon.vue";
import FlexRow from "@/components/FlexRow.vue";
import { CurrencyValue } from "@/components/tableElements";
import AppPopover from "@/components/AppPopover";
export default {
  name: 'PpcBAVsLastWeekSpendCell',
  components: {
    CurrencyValue,
    AppPopover,
    CalendarWithArrowLeftIcon,
    FlexRow
  },
  props: {
    item_id: {
      type: String,
      default: ""
    },
    currency: {
      type: String,
      default: ""
    },
    currency_precision: {
      type: String,
      default: ""
    },
    value: {
      type: Number
    },
    previous_week_value: {
      type: Number
    }
  }
};